import { IOperationAllow, Operation } from '..';
import {
  find as lfind,
  propOr as lpropOr,
  compose as lcompose,
} from 'lodash/fp';

export const canOperate =
  (operations: IOperationAllow[]) => (operation: Operation) =>
    lcompose(
      lpropOr(false, 'allow'),
      lfind<IOperationAllow>({
        operation,
      })
    )(operations);

export const disableOperationsHelpDesk = (operations: IOperationAllow[]) =>
  canOperate(operations)('helpDesk');
